export const fr = {
  joinNewsletter:
    "Abonnez-vous à notre infolettre pour avoir accès à des offres exclusives et être mis à jour des nouveautés. ",
};
